<template>
  <v-textarea
    v-bind="{...defaults, ...$attrs}"
    class="ol-textarea"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <slot />
  </v-textarea>
</template>

<script>
export default {
  name: 'OlTextarea',
  inheritAttrs: false,
  beforeCreate() {
    this.defaults = {
      filled: true,
      'background-color': 'white'
    }
  }
}
</script>
